'use strict';
// https://github.com/tc39/proposal-relative-indexing-method
require('../modules/es.string.at-alternative');
require('../modules/esnext.array.at');
require('../modules/esnext.typed-array.at');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/relative-indexing-method.js
// module id = 981
// module chunks = 31